import { render, staticRenderFns } from "./EventClick.vue?vue&type=template&id=72807b4e&"
import script from "./EventClick.vue?vue&type=script&lang=js&"
export * from "./EventClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports